import type { TCompradorPropostaSchema, TPropostaSchemaInput } from '@/features/proposta/brasil/domain/schemas'
import type { CompradorPessoaJuridicaSchemaInput } from '@/features/proposta/brasil/domain/schemas/compradores/comprador-pj.schema'
import { Cnpj } from '@/utils/cnpj'

export const transformarCompradorEVinculosEmClienteJuridicoECliente = (
  comprador: CompradorPessoaJuridicaSchemaInput,
): {
  clientePJ: TPropostaSchemaInput['cadastroCompradores']['clientesJuridicos'][number]
  clientePF: TPropostaSchemaInput['cadastroCompradores']['clientes'][number]
} => {
  const responsavel = comprador.responsavel!
  return {
    clientePJ: {
      cnpj: new Cnpj(comprador.dados.cnpj).removeFormatting(),
      razaoSocial: comprador.dados.razaoSocial,
      id: comprador.dados.id!,
      email: comprador.dados.email ?? '',
      tipo: 'PessoaJuridica',
      telefone: {
        numero: comprador.dados.telefone!.numero.replaceAll(/\D/g, ''),
        origem: comprador.dados.telefone!.origem!,
        principal: comprador.dados.telefone!.principal!,
      },
    },
    clientePF: {
      id: responsavel.dados.id!,
      tipoDoCliente: 'Contato',
      maiorDe18Anos: true,
      cpf: responsavel.dados.cpf.replaceAll(/\D/g, ''),
      nome: responsavel.dados.nome,
      imagem: responsavel.imagem,
      email: responsavel.contato.email!,
      estadoCivil: responsavel.estadoCivil?.status,
      regimeCasamento: responsavel.estadoCivil?.regimeCasamento,
      possuiUniaoEstavel: responsavel.estadoCivil?.uniaoEstavel
        ? responsavel.estadoCivil?.uniaoEstavel === 'sim'
        : null,
      profissaoId: responsavel.dados.profissaoId,
      nacionalidadeId: responsavel.dados.nacionalidadeId,
      telefone: {
        numero: responsavel.contato.telefone!.numero.replaceAll(/\D/g, ''),
        origem: responsavel.contato.telefone!.origem!,
        principal: true,
      },
    },
  }
}

export const transformarCompradorFormParaCompradorPJ = (
  comprador: CompradorPessoaJuridicaSchemaInput,
): TCompradorPropostaSchema => {
  return {
    clienteId: comprador.dados.id!,
    tipo: 'PessoaJuridica',
    vinculos:
      comprador?.responsavel?.tipo === 'Representante'
        ? [
            {
              clienteId: comprador.responsavel.dados.id!,
              tipo: comprador.responsavel.tipo,
            },
          ]
        : [],
  }
}
